import React from 'react';
import styles from './FaqParent.module.css';

import img1 from '../../assets/absolute3.png';
import img2 from '../../assets/absolute4.png';

import Button2 from '../button2/Button2';
import FAQ from '../faq/FAQ';

const FaqParent = () => {
    return (
        <div id="faqs" className={styles.parent}>
            <Button2 text="FAQ" />
            <h3 className={styles.head}>Let’s Clear <span>Things Up</span></h3>
            <FAQ />
            <img src={img1} alt="img1" className={styles.img1} />
            <img src={img2} alt="img2" className={styles.img2} />
        </div>
    )
}

export default FaqParent;